import React from 'react'
import { IStepHelpSteps } from 'app_types/components/helpSteps/helpStepsTypes';

const steps: IStepHelpSteps[] = [
  {
    target: '#menu',
    title: 'Menú lateral',
    placement: "auto",
    content: (
      <div>
        <div className="content">
          En este menú tienes acceso a Tutoriales y diferentes recursos y herramientas que ICONTEC tiene para ti.
        </div>
      </div>
    ),
  },
  {
    target: '#student_dashboard_user_info',
    title: 'Perfil',
    custom: {
      before: {
        clickElement: {
          target: '#student_dashboard_menu_overlay'
        }
      }
    },
    content: (
      <div>
        <div className="content">
          En esta sección encuentras tu tarjeta de perfil, puedes editar la información y colocar tu foto o avatar.
        </div>
      </div>
    ),
  },
  {
    target: '#students_header',
    title: 'Menú Superior',
    content: (
      <div>
        <div className="content">
          En esta sección encuentras botones para devolverte a la pagina principal del campus, puedes ingresar a los cursos y puedes salir del sitio.
        </div>
      </div>
    ),
  },
  {
    target: '#student_dashboard_currents_tab',
    title: 'Información de tus cursos Activos',
    content: (
      <div>
        <div className="content">
          Aquí puedes seleccionar tus programas de formación (cursos/programas/diplomados) que están en curso (activos) y abajo en la pantalla se filtra toda la información correspondiente a este curso en las secciones siguientes.
        </div>
      </div>
    ),
  },
  {
    target: '#student_dashboard_join_course',
    title: 'Ingreso a cursos activos',
    content: (
      <div>
        <div>
          Para acceder rápidamente al curso puedes hacerlo al lado del nombre una vez lo selecciones el botón <span style={{ color: 'var(--secondary)', fontWeight: 700 }}>“ingresar al curso”</span> o bien en el botón del menú superior.
        </div>
      </div>
    ),
  },
  {
    target: '#student_dashboard_learning_path',
    title: 'Ruta de aprendizaje',
    custom: {
      before: {
        clickElement: {
          target: '#student_dashboard_learning_path_toggle',
          delay: 200,
        }
      }
    },
    content: (
      <div>
        <div className="content">
          En esta sección obtienes información sobre los módulos que conforman tu curso, programa o diplomado.
        </div>
      </div>
    ),
  },
  {
    target: '#student_dashboard_achieved_module',
    title: 'Calificaciones logradas',
    content: (
      <div>
        <div className="content">
          En esta sección puedes conocer los resultados de las actividades evaluativas finalizadas.
        </div>
      </div>
    ),
  },
  {
    target: '#scheduling-button',
    title: 'Información del curso - Programación',
    custom: {
      before: {
        clickElement: {
          target: '#scheduling-button',
          delay: 200
        }
      },
      childs: [
        {
          target: '#student-dashboard-scheduling-table-join',
          title: 'Información del curso - Programación',
          content: (
            <div>
              <div className="content">
                Aquí también encuentras el link para ingresar al curso.
              </div>
            </div>
          ),
        },
      ],
    },
    content: (
      <div>
        <div className="content">
          En esta ubicación encuentras la información sobre la programación de actividades de tu curso.
        </div>
      </div>
    ),
  },
  {
    target: '#history-button',
    title: 'Histórico de sesiones',
    custom: {
      before: {
        clickElement: {
          target: '#history-button',
          delay: 200
        }
      }
    },
    content: (
      <div>
        <div className="content">
          Aquí encuentras la información sobre sesiones anteriores a la fecha de consulta.
        </div>
      </div>
    ),
  },
  {
    target: '#activities-button',
    title: 'Evaluación y Exámenes',
    custom: {
      before: {
        clickElement: {
          target: '#activities-button',
          delay: 200
        }
      }
    },
    content: (
      <div>
        <div className="content">
          En esta sección también encuentras la información sobre las evaluaciones y exámenes programados en tu curso. Aquí puedes ingresar directamente al exámen.
        </div>
      </div>
    ),
  },
  {
    target: '#student_dashboard_history_tab',
    title: 'Cursos Terminados',
    custom: {
      before: {
        clickElement: {
          target: '#student_dashboard_history_tab',
          delay: 200
        }
      },
      childs: [
        {
          target: '#service-button',
          title: 'Evalúa nuestro servicio',
          custom: {
            before: {
              clickElement: {
                target: '#service-button',
                delay: 200
              }
            },
          },
          content: (
            <div>
              <div>
                En la sección <span style={{ color: 'var(--secondary)', fontWeight: 700 }}>“Terminados”</span> encuentras el link para realizar tus evaluaciones de satisfacción, esto nos ayuda a mejorar en nuestro servicio.
              </div>
            </div>
          ),
        },
      ]
    },
    content: (
      <div>
        <div className="content">
          En esta sección encuentras los cursos que ya han finalizado, selecciona el curso que quieres revisar y abajo encuentras información sobre su ejecución.
        </div>
      </div>
    ),
  },
  {
    target: '#student_dashboard_certifications_tab',
    title: 'Certificaciones',
    custom: {
      before: {
        clickElement: {
          target: '#student_dashboard_certifications_tab',
          delay: 200
        }
      },
      childs: [
        {
          target: '#student_dashboard_certifications_table',
          title: 'Certificaciones',
          content: (
            <div>
              <div className="content">
                En esta sección puedes descargar las certificaciones habilitadas y accedes a link de redes sociales para publicarlas.
              </div>
            </div>
          ),
        }
      ],
    },
    content: (
      <div>
        <div className="content">
          En esta sección puedes descargar las certificaciones habilitadas y accedes a link de redes sociales para publicarlas.
        </div>
      </div>
    ),
  },
  {
    target: '#support-main-section',
    title: 'Asistente Virtual Daniela',
    custom: {
      before: {
        clickElement: {
          target: '#support-main-button',
          delay: 100
        }
      },
    },
    content: (
      <div>
        <div>
          Con el asistente virtual <strong>Daniela</strong> puedes acceder al <strong>soporte estudiantil</strong>, haz clic en el icono de ayuda (<span style={{ fontWeight: 700, color: 'var(--secondary)' }}>?</span>) y utiliza la mesa de ayuda o el WhatsApp denominado <span style={{ fontWeight: 700, color: 'var(--secondary)' }}>¿NO puedes ingresar al curso?</span>
        </div>
      </div>
    ),
  },
  {
    target: '#student_dashboard_news',
    title: 'Mantengámonos al día',
    custom: {
      before: {
        clickElement: {
          target: '#support-close-button',
          delay: 100
        }
      },
    },
    content: (
      <div>
        <div className="content">
          En esta sección encuentras noticias de tu interés sobre <strong>Educación de ICONTEC</strong>
        </div>
      </div>
    ),
  },
  {
    target: '#student_dashboard_related_courses',
    title: 'Cursos relacionados',
    content: (
      <div>
        <div className="content">
          En esta sección ICONTEC te sugiere otros programas de formación que puedes adquirir para impulsar aún más tu desarrollo y mantenerte actualizado.
        </div>
      </div>
    ),
  },
]

export default steps;
